import React, { useState } from "react";
import {
  GridFill,
  PeopleFill,
  HeartPulseFill,
  BarChartFill,
  CalendarCheckFill,
  PersonLinesFill,
  FileEarmarkBarGraphFill,
  Clipboard2PulseFill,
  HospitalFill,
  GearFill,
  ChevronDown,
  ChevronRight,
  BoxArrowRight,
} from "react-bootstrap-icons";

import "bootstrap/dist/css/bootstrap.min.css";


const Dashboard = () => {
  
  return (
    <div className="container-fluid">

        {/* Main Content */}
        <div
          style={{
            background: "#f1f5f9",
            minHeight: "100vh",
          }}
        >



          {/* Dashboard Content */}
          <div className="p-4">

            {/* Dynamic Cards */}
            <div className="row">

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Total Employee</h6>
                    <h2>1,250</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Present Today</h6>
                    <h2>1,180</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Pending Leave</h6>
                    <h2>32</h2>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body">
                    <h6>Medical Cases</h6>
                    <h2>14</h2>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
    </div>
  );
};

export default Dashboard;